var a={small:{value:"1.25"},medium:{value:"1.5"},large:{value:"2"}};export{a as lineHeights};
